import { render, staticRenderFns } from "./QjListTemplateWhatsApp.vue?vue&type=template&id=7f150e44"
import script from "./QjListTemplateWhatsApp.vue?vue&type=script&lang=js"
export * from "./QjListTemplateWhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports